export default __webpack_public_path__ + "static/20-e0d2e0e5c21a06145ad031dbc964fc94.png";